import { IComponentOptions } from "angular";
import { MachineDetailProgressiveConfigurationEditComponentController } from "./controller";

export const vsComponentName =
  "machineDetailProgressiveConfigurationEditComponent";

export const MachineDetailProgressiveConfigurationEditComponentOptions: IComponentOptions =
  {
    controller: MachineDetailProgressiveConfigurationEditComponentController,
    controllerAs: "componentController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machine: "<",
      machineConfiguration: "<",
      machineConfigurationProgressiveInformation: "<",
    },
  };
